export function isCustomStoreOrder(order) {
  return order.orderForCustomStore;
}